<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="signup-page-contaier pt-md-4 py-2 px-md-5 px-3">
    <div class="row no-gutters">
      <div class="offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 col-12">
        <div class="card border-0">
          <div class="login-page-card d-flex flex-sm-row flex-column py-2 pb-md-4 card-body">
            <div class="login-poster-section col-sm-6 col-12 oder-sm-0 order-1">
                <div class="d-flex justify-content-center align-items-center h-100">
                  <img src="assets/img/login-blank.png" alt="login" class="img-fluid">
                </div> 
            </div>
            <div class="login-form-section col-sm-6 col-12 order-sm-1 order-0">
              <div class="form-header">
                  <div class="company-logo pt-2 px-2">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                      <img src="assets/img/logo-4.png" alt="logo" class="img-fluid w-70px mx-1">
                      <h1 class="m-0 title">Smart<span class="dine">Dine</span></h1>
                    </div>
                    <div class="text-center pt-2">
                      <div class="form-title mb-2">Log In to your account</div>
                      <div class="form-subtitle pb-2 px-sm-2 px-4">Don't have an account? Click to <a href="#" routerLink="/sign-up" class="fw-bold text-decoration-none text-color-secondary">Sign Up</a></div>
                    </div>
                  </div>
    
                  <form class="form" [formGroup]="form" (ngSubmit)="loginAction()" *ngIf="showLoginForm">
                    <ion-list class="px-sm-4 px-2">

                      <ion-item lines="none" class="error" *ngIf="errorMessage">
                        <ion-label class="ion-text-center error-message bg-light" [innerText]="errorMessage"></ion-label>
                      </ion-item>

                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="iconName"></ion-icon>
                        <ion-select formControlName="countryCode" class="country-code-input mt-n-12px" [hidden]="isCountryCodeHidden()">
                          <ion-select-option value="+91">+91</ion-select-option>
                          <ion-select-option value="+1">+1</ion-select-option>
                        </ion-select>
                        <ion-input class="mt-n-12px mx-1" placeholder="Mobile Number or Email" autocomplete="off" type="text" formControlName="username"></ion-input>
                      </ion-item>

                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="hidePassword?'lock-closed-outline':'lock-open-outline'"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="Password" autocomplete="off" [type]="hidePassword?'password':'text'" formControlName="password"></ion-input>
                        <ion-button clear fill="clear" slot="end" class="pwd-visibility-button mt-n-12px" (click)="togglePasswordVisibility()" [title]="hidePassword?'Show':'Hide'">
                          <ion-icon class="form-input-icon" [name]="hidePassword?'eye-outline':'eye-off-outline'" [title]="hidePassword?'Show':'Hide'"></ion-icon>
                        </ion-button>
                      </ion-item>

                      <div class="d-flex justify-content-end align-items-center pb-3 px-3">
                        <ion-label class="ion-text-end forget-pwd-link"><span class="link" routerLink="/password-recovery">Forgot Password?</span>
                        </ion-label>
                      </div>
                    </ion-list>
                
                    <div class="actions px-sm-4 px-2">
                      <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                        Log in
                      </ion-button>
                    </div>
                  </form>
    
                  <!-- Password Change Form -->
                  <form class="form" [formGroup]="pwdChangeForm" (ngSubmit)="changePwdAction()" *ngIf="showPasswordChangeForm">
                    <ion-list class="px-sm-4 px-2">
                      <ion-item lines="none" class="error" *ngIf="errorMessage">
                        <ion-label class="ion-text-center error-message bg-light" [innerText]="errorMessage"></ion-label>
                      </ion-item>
                
                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="lock-closed-outline"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="New Password" autocomplete="off" type="password" formControlName="newPassword"></ion-input>
                      </ion-item>
                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="checkmark-done-outline"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="Re-enter New Password" autocomplete="off" type="password" formControlName="reenterNewPassword"></ion-input>
                      </ion-item>
                    </ion-list>
                
                    <div class="px-sm-4 px-2">
                      <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                        Change Password
                      </ion-button>
                      <div class="mb-2 ion-text-center divider"><span class="py-2 px-3 text-white">OR</span></div>
                      <ion-button class="mb-3 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/sign-up" fill="outline">
                        Sign up
                      </ion-button>
                    </div>
                  </form>
    
                  <!-- Code Verification Form -->
                  <form class="form" [formGroup]="codeVerificationForm" (ngSubmit)="codeVerificationAction()" *ngIf="showCodeConfirmationForm">
                    <ion-list class="px-sm-4 px-2">
                      <ion-item lines="none" class="error" *ngIf="errorMessage">
                        <ion-label class="ion-text-center" [innerText]="errorMessage"></ion-label>
                      </ion-item>
                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 mt-n-3px form-input-icon" slot="start" name="checkmark-done-outline"></ion-icon>
                        <ion-input class="mx-1 mt-n-12px" placeholder="Verification Code" autocomplete="off" type="text" formControlName="verificationCode"></ion-input>
                      </ion-item>
                    </ion-list>
                
                    <div class="px-sm-4 px-2">
                      <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                        Confirm
                      </ion-button>
                      <div class="mb-2 ion-text-center divider"><span class="py-2 px-3 text-white">OR</span></div>
                      <ion-button class="mb-3 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/sign-up" fill="outline">
                        Sign up
                      </ion-button>
                    </div>
                  </form>
    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>